module.exports = __webpack_public_path__ + "files/db812d8a70a4e88e888744c1c9a27e89.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.woff2?v=4.5.0
 ** module id = 840
 ** module chunks = 0
 **/